import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const deadSession: ThemeUICSSObject = {
  /* PREPEND HERE */
  display: 'flex',
  flexDirection: 'column',
  gap: 3,

  '.textAndIcon': {
    display: 'flex',
    gap: 5,

    svg: {
      filter: 'saturate(2.2)',
      color: 'iconWarning',
    },
  },

  '.goHomeLink': {
    color: 'palette.text.link',
    p: '3px',
  },
};

export default deadSession;
